<template>
  <ul class="c-page-nav__list" :class="{'is-child': isChild, 'is-open': isOpen}">
    <li
      class="c-page-nav__item"
      :class="{'is-open': $route.path === `/content${link.data.page_url}`}"
      v-for="link in links"
      :key="link.id"
    >
      <span class="inline-link">
        <icon
          name="arrow"
          class="arrow"
          v-if="link.children && link.children.length > 0"
          :class="{'is-down':navOpen === link.id}"
          width="10"
          height="10"
          @click="toggleNavOpen(link.id)"
        ></icon>
        <page-navigation-link
          :link="link"
          :key="link.id"
          :isChild="isChild"
          :hasChildren="link.children.length >= 1"
        ></page-navigation-link>
        <page-navigation-list
          v-if="link.children.length >=1"
          :links="link.children"
          :isChild="true"
          :is-open="navOpen === link.id"
        ></page-navigation-list>
      </span>
    </li>
  </ul>
</template>

<script>
import PageNavigationList from "@/components/PageNavigationList";
import PageNavigationLink from "@/components/PageNavigationLink";

export default {
  name: "page-navigation-list",

  components: {
    PageNavigationList,
    PageNavigationLink
  },

  methods: {
    toggleNavOpen(id) {
      if (this.navOpen === id) {
        this.navOpen = null;
        return;
      }
      this.navOpen = id;
    }
  },

  props: {
    links: Array,
    isChild: Boolean,
    isOpen: Boolean
  },
  data() {
    return {
      navOpen: null
    };
  }
};

</script>

<style lang="scss" scoped>
.c-page-nav__list {
  margin: 0;
  margin-left: 25px;
  ul {
    margin-left: 0;
  }
}
.c-page-nav__item {
  &.is-open > .c-page-nav__link > .svg-icon {
    transform: rotate(90deg);
  }
}

//use css to show only the parent + descendants of the current selected item

//hide sub-menus by default
.c-page-nav__list {
  ul {
    display: none;

    &.is-open {
      display: block;
    }
  }

  //display siblings of current active link
  .is-active ~ ul {
    display: block;
  }

  //hide grandchildren of current item
  // .is-open ul ul {
  //   display: none;
  // }
}

.inline-link {
  display: block;

  a {
    display: inline-block;
  }
}

.arrow {
  transition: all ease-in-out 0.2s;
  float: left;
  cursor: pointer;
  margin-right: 0;
  margin-left: -20px;
  transform: translateY(50%);
  transform-origin: 50% 100%;

  &.is-down {
    transform: rotate(90deg) translate(-5%,50%);
  }
}
</style>
